import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';
import {numberRules} from 'utils/formRules';

export const infoFields: ModalFormFieldTypes[] = [
	{
		name: 'name',
		label: 'Անուն`',
		type: 'text',
		isRequired: false,
		inputProps: {
			placeholder: 'Անուն'
		},
		colProps: {
			lg: 6,
			xs: 24
		}
	},
	{
		name: 'lastname',
		type: 'text',
		label: 'Ազգանուն`',
		isRequired: false,
		inputProps: {
			placeholder: 'Ազգանուն'
		},
		colProps: {
			lg: 6,
			xs: 24
		}
	},
	{
		name: 'middleName',
		label: 'Հայրանուն`',
		isRequired: false,
		type: 'text',
		inputProps: {
			placeholder: 'Հայրանուն'
		},
		colProps: {
			lg: 6,
			xs: 24
		}
	},
	{
		name: 'telephone',
		label: 'Հեռախոս`',
		type: 'text',
		isRequired: false,
		inputProps: {addonBefore: '+', placeholder: 'Հեռախոս'},
		rules: [numberRules],
		colProps: {
			lg: 6,
			xs: 24
		}
	}
];
